import { render } from "./DriverCreate.vue?vue&type=template&id=e15d4390"
import script from "./DriverCreate.vue?vue&type=script&lang=js"
export * from "./DriverCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__